import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	fetch: false,
	params: {
		offset: 0,
		limit: 40,
	},
};

const countryListSlice = createSlice({
	name: "country_list",
	initialState,
	reducers: {
		get: (state) => {
			if (state.list.length === 0) {
				state.fetch = true;
				if (state.list.length) {
					state.params.offset = state.params.offset + state.params.limit;
				}
			}
		},
		set: (state, action) => {
			state.list = action.payload;
			state.fetch = false;
		},
		drop: () => initialState,
	},
});

export const countryListActions = countryListSlice.actions;
export const countryListReducer = countryListSlice.reducer;
